export default __webpack_public_path__ + "static/favicon-ed5eb98ca3c463eea287e25ded568eb2.ico";